import axios from 'axios';
import SnackbarUtils from 'src/utils/snackbarUtil';

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/v1`,
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status) {
      const { status } = error.response;

      if (status === 401) {
        SnackbarUtils.error(error?.response?.data?.message);
      }
    }

    return Promise.reject(error);
  },
);
